import BillOfMaterials from '@modules/BillOfMaterials/Components/BillOfMaterials/BillOfMaterials';
import React from 'react';

const BillOfMaterialsPage: React.FC = () => {
    return <BillOfMaterials />;
};

export default BillOfMaterialsPage;
